import {gql, useMutation} from "@apollo/client";

const CREATE_ORGANIZATION_USER = gql`
    mutation CreateOrganizationUser(
        $organizationId: Int!
        $teamId: Int
        $seasonId: Int
        $role: Int!
        $firstName: String!
        $lastName: String!
        $email: String!
        $mobile: String
        $gender: String
        $dob: Date
    ) {
        createOrganizationUser(
            organizationId: $organizationId
            teamId: $teamId
            seasonId: $seasonId
            role: $role
            firstName: $firstName
            lastName: $lastName
            email: $email
            mobile: $mobile
            gender: $gender
            dob: $dob
        ) {
            success
            profileId
            fullName
            activationSent
            errors
        }
    }
`;

export default function CreateOrganizationUserMutation() {
    return useMutation(CREATE_ORGANIZATION_USER);
}
